module.exports = __webpack_public_path__ + "static/media/Test14.fc2e64a6.bmp";